import BaseService from "../baseService";
class UnidadesConsumidoras extends BaseService {
    constructor(id) {
        const resource = "unidades-consumidoras";
        let relationship = {
            view: 'view'
        };
        super(id, relationship, resource);
    }
}

export default (id) => new UnidadesConsumidoras(id);
